import { render, staticRenderFns } from "./EditAccessRight.vue?vue&type=template&id=f38e2b60"
import script from "./EditAccessRight.vue?vue&type=script&lang=js"
export * from "./EditAccessRight.vue?vue&type=script&lang=js"
import style0 from "./EditAccessRight.vue?vue&type=style&index=0&id=f38e2b60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports